<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
</button>

<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="row">
            <div class="col-md-12">
                <div mat-dialog-title>
                    <mat-icon class="nav-icon">monetization_on</mat-icon>New Refund Request
                </div>
            </div>
        </div>

        <div class="mat-dialog-content">
            <form [formGroup]="refundForm" (ngSubmit)="refundSubmit()">
                <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Transaction Reference Number</mat-label>
                        <input matInput formControlName="AFSTransactionId" [(ngModel)]="data.AFSTransactionId" required
                            readonly [ngClass]="{'is-invalid':submitted && forms.AFSTransactionId.errors}">
                        <mat-error *ngIf="submitted && forms.AFSTransactionId.errors" class="invalid-feedback">
                            <div *ngIf="forms.AFSTransactionId.errors.required"> This field is required </div>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Refund Amount</mat-label>
                        <input matInput type="number" formControlName="RefundAmount" [(ngModel)]="data.RefundAmount"
                            required appNumericOnly appNumeric
                            [ngClass]="{'is-invalid':submitted && forms.RefundAmount.errors}">
                        <mat-error *ngIf="submitted && forms.RefundAmount.errors" class="invalid-feedback">
                            <div *ngIf="forms.RefundAmount.errors.required"> This field is required </div>
                        </mat-error>
                    </mat-form-field>
                    <div class="text" *ngIf="this.refundDataFromService > this.dataFromService">Requested amount should not be more than the actual amount.</div>
                    <div class="text" *ngIf="this.refundForm.value.RefundAmount > this.dataFromService">Requested amount should not be more than the actual amount.</div>
                    <div class="text" *ngIf="this.refundDataFromService + this.refundForm.value.RefundAmount > this.dataFromService">
                        You can refund only ${{this.dataFromService - this.refundDataFromService }} or below but not more than that. 
                    </div>
                    <!-- <div *ngIf="refundAttempts>0 && isRefunded==0 && isCancelled==0">{{'Refund Failed'}}
                    </div> -->
                </div>
                <!-- "ref"{{ this.refundForm.value.RefundAmount}}
                sc{{ this.dataFromService}} -->
                <!-- {{this.dataFromService - this.refundDataFromService >= this.dataFromService}}
                {{this.refundDataFromService}} -->
                <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Reason</mat-label>
                        <mat-select matInput type="text" formControlName="ReasonCode" [(ngModel)]="data.ReasonCode" required
                        [ngClass]="{'is-invalid':submitted && forms.ReasonCode.errors}">
                            <mat-option *ngFor="let reason of reason"
                                [value]="reason.reasonId.toString()">{{reason.reasonCode}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="submitted && forms.ReasonCode.errors" class="invalid-feedback">
                            <div *ngIf="forms.ReasonCode.errors.required"> This field is required </div>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Comment</mat-label>
                        <input matInput formControlName="Comment" [(ngModel)]="data.Comment">
                    </mat-form-field>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <mat-checkbox color="primary" formControlName="SendRequestedNotification"
                            [(ngModel)]="data.SendRequestedNotification">Send request
                            notification</mat-checkbox>
                    </div>
                    <div class="col-md-6">
                        <mat-checkbox color="primary" formControlName="SendProcessedNotification"
                            [(ngModel)]="data.SendProcessedNotification">Send process
                            notification</mat-checkbox>
                    </div>
                </div>
                <div class="buttonRow">
                    <button type="submit" mat-raised-button 
                        class="create" 
                        [disabled]= "this.refundForm.value.RefundAmount > this.dataFromService || 
                        this.refundDataFromService > this.dataFromService ||
                        this.refundDataFromService + this.refundForm.value.RefundAmount > this.dataFromService">Request
                        Refund</button>
                    <button type="reset" mat-raised-button (click)="onNoClick()" class="cancel">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>